<template>
 <div>
     <div class="row justify-content-center ">
         <div class="col-md-8 pt-3">
             <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Conditions</p>
         </div>
         <div class="col-md-4 pt-3 text-right pr-4">
             <a href="/my-health/conditions/edit" aria-label="My Conditions - Edit" class="color-sky-blue-3" v-if="cons.length > 0">
                 Edit
             </a>
         </div>
     </div>
     <div class="row justify-content-center ">
         <div class="col-md-12">
             <div class="col-md-12 mb-2">
                 <a href="/my-health/conditions/add" class="btn btn-primary btn-sb">Add new condition</a>
             </div>
             <ul class="list-group mb-3" v-if="cons.length>0">
                 <li :class="(c.prescriptions.length>0?'border-bottom-0 ':'')+'list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0'" v-for="(c, key) in cons" v-if="view_more || key < 4">
                     <div class="row">
                         <div class="col-md-9 sb-list-fitem-regular">
                             {{ c.cnd_sr ? c.cnd_srname : (c.condition_data?c.condition_data.cdd_name:'') }}
                             <div class="small" v-if="c.cnd_name">({{ c.cnd_name }})</div>
                         </div>
                         <div class="col-md-3 text-right sb-list-sitem">
                             <a href="#" class="text-danger" @click="deleteConById(c)" :aria-label="((c.cnd_sr ? c.cnd_srname : c.condition_data.cdd_name) + ' - Remove')">
                                 Remove
                             </a>
                         </div>
                     </div>
                     <ul class="list-group">
                         <li class="list-group-item border-top-0 border-left-0 border-right-0 pt-1 pb-1 sb-list-thitem-regular" v-for="p in c.prescriptions">
                             {{ p.pre_sr ? p.pre_srname : (p.prescription_data?p.prescription_data.prd_name:'') }}
                             ({{ p.pre_dosage }} {{ p.dosage ? p.dosage.dos_type : '' }})
                         </li>
                     </ul>
                 </li>
             </ul>
             <div v-if="cons.length>4" class="text-right mb-3 mr-3">
                 <a href="#" @click.prevent="view_more=!view_more" aria-label="View Less Conditions" v-if="view_more">View Less</a>
                 <a href="#" @click.prevent="view_more=!view_more" aria-label="View More Conditions" v-else>View More</a>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
export default {
    props:['conditions'],
    mounted() {
        this.listCon(true);
    },
    data() {
        return {
            route: '/api/conditions',
            cons: [],
            view_more: false
        }
    },
    methods: {
        listCon(fromProp = false) {
            if (fromProp) {
                this.cons = this.conditions;
                bus.$emit('listCon', this.cons);
            } else {
                this.$http.get(this.route)
                    .then(function(response) {
                        this.cons = response.data;
                        bus.$emit('listCon', this.cons);
                    }, (response) => {
                        this._handleErrors(response.data, '#con-form')
                    })
            }
        },
        deleteConById(con) {
            if (!confirm('Do you really want to delete this condition?'))
                return

            this.$http.delete(this.route + '/' + con.cnd_id)
                .then(function (response) {
                    this.listCon();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Condition was deleted!'
                    });
                    this.showModal = false;
                }, (response) => {
                    this._handleErrors(response.data, '#con-form')
                })
        },
        _handleErrors: function (items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        }
    }

}
</script>
